import { useMemo } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useUserPermissions } from "@/hooks/use-user-permissions";
import { AccessProfileSlug } from "@/types/user-profile";
import { getInitials } from "./freelancerCardShared";
import { OpenToWorkRing } from "./OpenToWorkRing";

interface FreelancerAvatarProps {
  nome: string;
  fotoUrl?: string | null;
  openToWork?: boolean | null;
  openToWorkObservadoEm?: string | null;
}

/** Iniciais do freelancer. A foto do LinkedIn aparece só para admins, em teste antes de liberar para todos. */
export function FreelancerAvatar({ nome, fotoUrl, openToWork, openToWorkObservadoEm }: FreelancerAvatarProps) {
  const { profileSlug } = useUserPermissions();
  const initials = useMemo(() => getInitials(nome), [nome]);
  const showPhoto = !!fotoUrl && profileSlug === AccessProfileSlug.Admin;

  return (
    <OpenToWorkRing openToWork={openToWork} observedAt={openToWorkObservadoEm} className="size-full">
      <Avatar className="size-full">
        {showPhoto && <AvatarImage src={fotoUrl} alt="" className="object-cover" />}
        <AvatarFallback className="bg-transparent">{initials}</AvatarFallback>
      </Avatar>
    </OpenToWorkRing>
  );
}
